import { ref } from 'vue';

export default (statics = []) => {
    const kpiStdValues = ref([
        ...statics,
        { value: '计划标准', label: '计划标准' },
        { value: '历史标准', label: '历史标准' },
        { value: '行业标准', label: '行业标准' },
        { value: '国际标准', label: '国际标准' },
        { value: '其他标准', label: '其他标准' },
    ]);
    return {
        kpiStdValues,
    };
};
